export default __webpack_public_path__ + "static/media/pipeUp2.2a3948af.png";